import R from 'ramda';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getWorkTypeNameById,
  getSubWorkTypeNameById,
  getMemberByUserId,
} from '../../utils';
import AgreementSection from './AgreementSection';
import { selectDealBlocksState } from '../../redux/selectors';
import getContent from '../ContractBlock/Contents';
import getState from '../Deals/DealEditPages/helpers/getState';

class AgreementTextWorkForHire extends Component {
  constructor() {
    super();
    this.state = {};
  }

  renderWorkRow(work, i) {
    const { workTypes, subWorkTypes, type } = this.props;
    let workTypeName = '';
    let subWorkTypeName = '';

    if (type === 'agreement-detail' && !work.date_accepted) {
      return null;
    }

    if (work.type) {
      workTypeName = getWorkTypeNameById(work.type, workTypes);
    }
    if (work.sub_type) {
      subWorkTypeName = getSubWorkTypeNameById(work.sub_type, subWorkTypes);
    }

    return (
      <tr key={i}>
        <td>{work.name}</td>
        <td>
          {workTypeName}, {subWorkTypeName}
        </td>
        <td>{moment(work.date_created).format('MM/DD/YYYY')}</td>
      </tr>
    );
  }

  renderCreateWorkRow() {
    const { fields, workTypes, subWorkTypes, type } = this.props;
    let workTypeName = '';
    let subWorkTypeName = '';

    if (type === 'create') {
      if (fields.type) {
        workTypeName = getWorkTypeNameById(fields.type, workTypes);
      }
      if (fields.subtype) {
        subWorkTypeName = getSubWorkTypeNameById(fields.subtype, subWorkTypes);
      }

      return (
        <tr>
          <td>{fields.name}</td>
          <td>
            {workTypeName}, {subWorkTypeName}
          </td>
          <td>{moment().format('MM/DD/YYYY')}</td>
        </tr>
      );
    }
  }

  renderWorks() {
    const { works, type } = this.props;

    if (type === 'create' || (works && works.length)) {
      return (
        <div className="user-status">
          <table>
            <thead>
              <tr>
                <th>Work</th>
                <th>Type of Work</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {works && works.length
                ? works.map((work, i) => this.renderWorkRow(work, i))
                : null}
              {this.renderCreateWorkRow()}
            </tbody>
          </table>
        </div>
      );
    }
  }

  loadAgreementText() {
    const {
      contractBlocks,
      type,
      agreement,
      agreementContractBlocks,
      works,
      dealBlocks,
      members,
      dealUsers,
      isTestVersion,
    } = this.props;

    let dateEffect = moment().format('dddd, MMMM Do, YYYY');
    if (type !== 'create') {
      dateEffect = moment(agreement.date_created).format('dddd, MMMM Do, YYYY');
    }

    let sigUsers = [];
    let ownerships = [];

    if (works.length) {
      ownerships = works[0].work_ownership_info || [];
    }

    if (type !== 'create') {
      dealUsers.forEach((dealUser) => {
        if (dealUser.status === 'Accepted') {
          const invitee = this.props.invites.find(
            (invite) => invite.invitee === dealUser.user
          );
          const member = getMemberByUserId(dealUser.user, members);
          let userInfo = {};

          if (member && member.user_info) {
            const user = member.user_info;
            const ownership = R.find(R.propEq('user', dealUser.user))(
              ownerships
            );

            if (ownership) {
              if (agreement.completed) {
                userInfo = {
                  ...ownership,
                  // name: invitee.name,
                  // address: user.address,
                  // city: user.city,
                  // state: user.state,
                  // postal: user.postal,
                  // country: user.country
                  email: user.email,
                  name: ownership.name === '' ? invitee.name : ownership.name,
                  address:
                    ownership.address === '' ? user.address : ownership.address,
                  city: ownership.city === '' ? user.city : ownership.city,
                  state: ownership.state === '' ? user.state : ownership.state,
                  postal:
                    ownership.postal === '' ? user.postal : ownership.postal,
                  country:
                    ownership.country === '' ? user.country : ownership.country,
                };
              } else {
                userInfo = {
                  use_company_name: ownership.use_company_name,
                  company_name: ownership.company_name,
                  user_title: ownership.user_title,
                  email: user.email,
                  name: invitee.name,
                  address: user.address,
                  city: user.city,
                  state: user.state,
                  postal: user.postal,
                  country: user.country,
                };
              }
            }

            sigUsers.push({
              user,
              dealUser,
              ...userInfo,
            });
          }
        }
      });
    }

    const options = {
      dateEffect,
      sigUsers,
      hasWork: type === 'create' || (works && works.length),
    };

    if (contractBlocks.length) {
      contractBlocks.forEach((block, i) => {
        let content = block.content || '';
        let changeOptions = block.options;

        if (type !== 'create' && agreementContractBlocks) {
          let index = R.findIndex(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          if (index !== -1) {
            content = agreementContractBlocks[index].content;
            changeOptions = JSON.parse(agreementContractBlocks[index].options);
          }
        }

        if (type === 'deal-edit' && dealBlocks && isTestVersion) {
          let index = R.findIndex(R.propEq('id', block.id))(dealBlocks);
          if (index !== -1 && dealBlocks[index].changes) {
            const blockContent = getContent(
              block.name,
              dealBlocks[index].changes,
              {
                type: agreement.type,
                state: getState(
                  !isTestVersion,
                  contractBlocks,
                  agreementContractBlocks,
                  dealBlocks
                ),
              }
            );
            content = blockContent.content;
            changeOptions = dealBlocks[index].changes;
          }
        }

        if (
          block.name === 'Dispute Resolution' &&
          changeOptions &&
          isTestVersion
        ) {
          const blockContent = getContent(block.name, changeOptions, {
            state: getState(
              !isTestVersion,
              contractBlocks,
              agreementContractBlocks,
              dealBlocks
            ),
          });
          content = blockContent.content;
        }

        if (block.name === 'Contribution') {
          options['contributor'] = '[CONTRIBUTOR]';
          options['contributor_address'] = '';
          options['owner'] = '[OWNER]';
          options['owner_address'] = '';

          if (changeOptions && changeOptions.contributor) {
            const member = getMemberByUserId(
              changeOptions.contributor,
              members
            );
            let contributor =
              member && member.user_info ? member.user_info : null;
            if (type === 'create') {
              if (contributor) {
                let contributorName = contributor.name;
                contributorName =
                  contributor.use_company_name && contributor.company_name
                    ? contributor.company_name
                    : contributor.name;
                options['contributor'] = contributorName;
                options[
                  'contributor_address'
                ] = `${contributor['address']}, ${contributor['city']}, ${contributor['state']} ${contributor['postal']}`;
              }

              const nonContributors = R.filter(
                (member) =>
                  member.user !== parseInt(changeOptions.contributor, 10),
                members
              );
              if (nonContributors.length) {
                const owner = nonContributors[0].user_info;
                let ownerName = owner.name;
                ownerName =
                  owner.use_company_name && owner.company_name
                    ? owner.company_name
                    : ownerName;
                options['owner'] = ownerName;
                options[
                  'owner_address'
                ] = `${owner['address']}, ${owner['city']}, ${owner['state']} ${owner['postal']}`;
              }
            } else if (dealUsers) {
              if (contributor) {
                let contributorName = contributor.name;
                const ownership = R.find(
                  R.propEq('user', parseInt(changeOptions.contributor, 10))
                )(ownerships);

                if (ownership) {
                  if (agreement.completed) {
                    contributor = {
                      ...ownership,
                      // name: contributor.name,
                      // address: contributor.address,
                      // city: contributor.city,
                      // state: contributor.state,
                      // postal: contributor.postal,
                      // country: contributor.country
                      name:
                        ownership.name === ''
                          ? contributor.name
                          : ownership.name,
                      address:
                        ownership.address === ''
                          ? contributor.address
                          : ownership.address,
                      city:
                        ownership.city === ''
                          ? contributor.city
                          : ownership.city,
                      state:
                        ownership.state === ''
                          ? contributor.state
                          : ownership.state,
                      postal:
                        ownership.postal === ''
                          ? contributor.postal
                          : ownership.postal,
                      country:
                        ownership.country === ''
                          ? contributor.country
                          : ownership.country,
                    };
                  }
                  contributorName =
                    contributor.use_company_name && contributor.company_name
                      ? contributor.company_name
                      : contributor.name;
                }
                options['contributor'] = contributorName;
                options[
                  'contributor_address'
                ] = `${contributor['address']}, ${contributor['city']}, ${contributor['state']} ${contributor['postal']}`;
              }

              const nonContributors = R.filter(
                (dealUser) =>
                  dealUser.type === 'member' &&
                  dealUser.user !== parseInt(changeOptions.contributor, 10),
                dealUsers
              );
              if (nonContributors.length) {
                const member = getMemberByUserId(
                  nonContributors[0].user,
                  members
                );

                if (member && member.user_info) {
                  let owner = member.user_info;
                  let ownerName = owner.name;
                  const ownership = R.find(
                    R.propEq('user', parseInt(owner.id, 10))
                  )(ownerships);

                  if (ownership) {
                    if (agreement.completed) {
                      owner = {
                        ...ownership,
                        // name: owner.name,
                        // address: owner.address,
                        // city: owner.city,
                        // state: owner.state,
                        // postal: owner.postal,
                        // country: owner.country
                        name:
                          ownership.name === '' ? owner.name : ownership.name,
                        address:
                          ownership.address === ''
                            ? owner.address
                            : ownership.address,
                        city:
                          ownership.city === '' ? owner.city : ownership.city,
                        state:
                          ownership.state === ''
                            ? owner.state
                            : ownership.state,
                        postal:
                          ownership.postal === ''
                            ? owner.postal
                            : ownership.postal,
                        country:
                          ownership.country === ''
                            ? owner.country
                            : ownership.country,
                      };
                    }
                    ownerName =
                      owner.use_company_name && owner.company_name
                        ? owner.company_name
                        : owner.name;
                  }
                  options['owner'] = ownerName;
                  options[
                    'owner_address'
                  ] = `${owner['address']}, ${owner['city']}, ${owner['state']} ${owner['postal']}`;
                }
              }
            }
          }
        }

        options[block.name] = content;
      });
    }

    return this.renderTemplate(options);
  }

  renderTemplate = (options) => {
    const props = {
      type: this.props.type,
      completed: this.props.agreement && this.props.agreement.completed,
      editable: this.props.editable,
      tabName: this.props.tabName,
      isCurrentVersion: this.props.isCurrentVersion,
      isTestVersion: this.props.isTestVersion,
    };

    return (
      <div>
        <p>
          THIS WORK-FOR-HIRE AGREEMENT (the “Agreement”) is entered into on{' '}
          {options['dateEffect']} by and between&nbsp;
          {options['contributor']} (“Contributor”), having an address at{' '}
          {options['contributor_address']} and {options['owner']} (“Owner”),
          having an address at {options['owner_address']}.
        </p>
        <p>
          For good and valuable consideration, the receipt and sufficiency of
          which are hereby acknowledged, the parties hereby agree as follows:
        </p>

        <AgreementSection section="Services title" {...props}>
          {`<h5>1. Services</h5>`}
        </AgreementSection>
        <AgreementSection section="Contribution" {...props}>
          {`Contributor, an independent contractor engaged by Owner, has made or will make contributions to the work(s) described in Schedule A, attached hereto and incorporated herein by reference and which may be amended by agreement of the Parties from time to time, (such work(s) shall be individually and collectively referred to herein as the “Work(s)”) as follows: ${options['Contribution']} (“Contribution”).`}
        </AgreementSection>

        <AgreementSection section="Consideration title" {...props}>
          {props.type === 'create'
            ? `<h5 class="Consideration">2. Consideration</h5>`
            : `<h5>2. Consideration</h5>`}
        </AgreementSection>
        <AgreementSection section="Consideration" {...props}>
          {options['Consideration']}
        </AgreementSection>

        <AgreementSection section="Ownership title" {...props}>
          {`<h5>3. Ownership</h5>`}
        </AgreementSection>
        <AgreementSection section="Ownership" {...props}>
          As between Owner and Contributor, all right, title and interest,
          including copyright, in and to the Work(s) and the services,
          Contribution, and materials provided by Contributor in connection with
          this Agreement and the Work(s) are “works made for hire” for Owner
          under the U.S. Copyright Act, and to the extent Contributor is deemed
          to have any ownership interest therein, Contributor hereby irrevocably
          assigns all right, title and interest therein, including copyright, to
          Owner in perpetuity throughout the world and in all media now known or
          hereafter devised. Contributor shall not distribute, display,
          reproduce, or otherwise make use of the Work(s), in whole or in part,
          in any manner or for any purpose without prior written consent from
          Owner.
        </AgreementSection>

        <AgreementSection section="Credit title" {...props}>
          {props.type === 'create'
            ? `<h5 class="Credit">4. Credit</h5>`
            : `<h5>4. Credit</h5>`}
        </AgreementSection>
        <AgreementSection section="Credit" {...props}>
          {options['Credit']}
        </AgreementSection>

        <AgreementSection
          section="Representations & Warranties title"
          {...props}
        >
          {`<h5>5. Representations & Warranties</h5>`}
        </AgreementSection>
        <AgreementSection section="Representations&Warranties" {...props}>
          Contributor warrants and represents that: (a) except as disclosed to
          Owner in writing, Contributor is not a member of any union, guild, or
          similar professional or trade organizations; (b) that Contributor is
          not subject to any contract or other agreement which would prohibit or
          limit Contributor’s ability to enter into and perform the services
          contemplated by this Agreement; and (c) that any and all contributions
          and materials provided by Contributor in connection with this
          Agreement and/or the Work(s) are wholly original and do not infringe
          on the rights, including, without limitation, copyright, trademark,
          rights of publicity, rights of privacy, and contractual rights, of any
          third party. Contributor hereby indemnifies, saves and holds Owner,
          its officers, directors, employees and assigns harmless from any and
          all claims, losses, damages, liabilities, costs and expenses
          (including reasonable attorney’s fees) which arise out of any breach
          by Contributor of any warranty, representation or agreement made by
          Contributor in this Agreement.
        </AgreementSection>

        <AgreementSection section="Confidentiality title" {...props}>
          {`<h5>6. Confidentiality</h5>`}
        </AgreementSection>
        <AgreementSection section="Confidentiality" {...props}>
          Neither party shall disclose to any third party any information to
          which such Party has had or will have access to concerning this
          Agreement and/or the Work(s), except as expressly permitted by the
          other Party/Parties in writing, as required by law, and to agents,
          managers, attorneys and other representatives of the disclosing Party
          who require such information.
        </AgreementSection>

        <AgreementSection section="Cure; Remedies title" {...props}>
          {props.type === 'create'
            ? `<h5 class="Cure;Remedies">7. Cure; Remedies</h5>`
            : `<h5>7. Cure; Remedies</h5>`}
        </AgreementSection>
        <AgreementSection section="Cure;Remedies" {...props}>
          {options['Cure; Remedies']}
        </AgreementSection>

        <AgreementSection section="Governing Law title" {...props}>
          {props.type === 'create'
            ? `<h5 class="GoverningLaw">8. Governing Law</h5>`
            : `<h5>8. Governing Law</h5>`}
        </AgreementSection>
        <AgreementSection section="GoverningLaw" {...props}>
          {options['Governing Law']}
        </AgreementSection>

        <AgreementSection section="Notices title" {...props}>
          {`<h5>9. Notices</h5>`}
        </AgreementSection>
        <AgreementSection section="Notices" {...props}>
          Except as otherwise set forth in this Agreement, all notices that
          either of the Parties may desire to serve upon the other shall be in
          writing and may be served by personal delivery, electronic mail, or
          certified or registered mail addressed to the respective party at the
          address set forth on the first page hereof, or such other address as
          said party may from time to time designate in writing. The date of
          personal delivery, mailing, or email of such notice will be deemed the
          date of the serving said notice, statement or payment.
        </AgreementSection>

        <AgreementSection section="Dispute Resolution title" {...props}>
          {props.type === 'create'
            ? `<h5 class="DisputeResolution">10. Dispute Resolution</h5>`
            : `<h5>10. Dispute Resolution</h5>`}
        </AgreementSection>
        <AgreementSection section="DisputeResolution" {...props}>
          {options['Dispute Resolution']}
        </AgreementSection>

        <AgreementSection section="Waiver title" {...props}>
          {`<h5>11. Waiver</h5>`}
        </AgreementSection>
        <AgreementSection section="Waiver" {...props}>
          No term or provision of this Agreement shall be deemed waived and no
          breach excused unless such waiver or consent shall be in writing
          signed and dated by the Party claimed to have waived or consented.
        </AgreementSection>

        <AgreementSection
          section="Relationship of the Parties title"
          {...props}
        >
          {`<h5>12. Relationship of the Parties</h5>`}
        </AgreementSection>
        <AgreementSection section="Relationship of the Parties" {...props}>
          The Parties shall have the relationship of independent contractors,
          and nothing in this Agreement shall be construed to place the Parties
          in the relationship of partners or joint venturers and neither party
          shall have the power to obligate or bind the other Party in any manner
          unless otherwise agreed in writing. Each party is solely responsible
          for filing all of its own tax returns, tax declarations and tax
          schedules and for the payment of all taxes (including without
          limitation social security taxes, federal, state and city income
          taxes, and sales and use taxes) required where due.
        </AgreementSection>

        <AgreementSection section="Additional Documents title" {...props}>
          {`<h5>13. Additional Documents</h5>`}
        </AgreementSection>
        <AgreementSection section="Additional Documents" {...props}>
          Each Party must execute all additional documents and take all actions
          as are reasonably requested by the other Parties in order to complete
          or confirm the transactions contemplated by this Agreement.
        </AgreementSection>

        <AgreementSection section="Reservation of Rights title" {...props}>
          {`<h5>14. Reservation of Rights</h5>`}
        </AgreementSection>
        <AgreementSection section="Reservation of Rights" {...props}>
          Any rights not expressly granted by a Party to this Agreement are
          reserved to that Party. Without limiting the foregoing, nothing in
          this Agreement shall be construed to prevent the Parties from creating
          a work not involving any other Party.
        </AgreementSection>

        <AgreementSection section="Successors and Assigns title" {...props}>
          {`<h5>15. Successors and Assigns</h5>`}
        </AgreementSection>
        <AgreementSection section="Successors and Assigns" {...props}>
          This Agreement shall be binding on any successors of the Parties. No
          Party shall have the right to assign its interests in or obligations
          under this Agreement to any other Party or third party, unless the
          prior written consent of the other Parties is obtained.
        </AgreementSection>

        <AgreementSection section="Entire Agreement title" {...props}>
          {`<h5>16. Entire Agreement</h5>`}
        </AgreementSection>
        <AgreementSection section="Entire Agreement" {...props}>
          This Agreement contains the entire understanding of the Parties
          relating to the subject matter herein contained and cannot be changed
          or terminated orally. Amendments to this Agreement shall be valid only
          if made in writing and agreed to by each of the Parties. This
          Agreement may be executed in counterparts, including by facsimile or
          other electronic means, each of which shall be deemed an original and
          all of which, when taken together, shall constitute one and the same
          instrument.
        </AgreementSection>

        <AgreementSection section="Section Headings title" {...props}>
          {`<h5>17. Section Headings</h5>`}
        </AgreementSection>
        <AgreementSection section="Section Headings" {...props}>
          Paragraph headings hereof are inserted only for the purpose of
          convenient reference. Such headings shall not be deemed to govern,
          limit, modify, or in any other manner affect the scope, meaning, or
          intent of the provisions of this Agreement, or any part or portion
          thereof, nor shall they otherwise be given any legal effect.
        </AgreementSection>

        <AgreementSection
          section="Severability of Invalid Provisions title"
          {...props}
        >
          {`<h5>18. Severability of Invalid Provisions</h5>`}
        </AgreementSection>
        <AgreementSection
          section="Severability of Invalid Provisions"
          {...props}
        >
          To the extent that any provision of this Agreement shall be determined
          to be invalid or unenforceable, the validity and enforceability of the
          remainder of such provision of this Agreement shall be unaffected. In
          the event any of the provisions are held invalid, illegal, or
          unenforceable, the Parties shall endeavor through good-faith
          negotiations to agree on a valid or enforceable provision which shall
          be a reasonable substitute in light of the tenor of the Agreement as
          originally executed and amended or modified form time to time prior to
          the determination of invalidity or unenforceability.
        </AgreementSection>

        <p>
          <b>
            Each Party hereby acknowledges and agrees that he or she has had the
            opportunity to consult with independent counsel of such Party’s own
            choice experienced in matters in connection with this Agreement,
            that any failure to do so is knowing and willful, and that this
            Agreement is the product of informed negotiation, and as such, shall
            not be construed against the drafter. Each Party further
            acknowledges and agrees that he or she has read and fully
            understands this Agreement, the contents hereof, and the legal
            consequences thereof.
          </b>
        </p>

        <p>
          This agreement can be signed in counterparts and by electronic means
          via services provided by Cosynd, Inc. and our signature below will
          indicate our agreement to the above.
        </p>

        {options['sigUsers'].map((sigUser, i) => {
          if (sigUser['use_company_name']) {
            return (
              <div className="sig-block" key={sigUser['dealUser']['id']}>
                <div className="deal-user-info">
                  <span className="deal-user-name">
                    <strong>{sigUser['company_name']}</strong>
                  </span>
                </div>
                <div className="sig-holder">
                  <img
                    src={sigUser['dealUser']['signature']}
                    role="presentation"
                  />
                </div>
                <div className="deal-user-info">
                  <span className="deal-user-name">
                    <strong>By {sigUser['name']}</strong>
                  </span>
                  <span className="deal-user-email">
                    It's {sigUser['user_title']}
                  </span>
                  <span className="deal-user-email">{sigUser['email']}</span>
                  <span className="deal-user-address">
                    {sigUser['address']}
                  </span>
                  <span className="deal-user-address">
                    {sigUser['city']
                      ? `${sigUser['city']}, ${sigUser['state']} ${sigUser['postal']}`
                      : `${sigUser['state']} ${sigUser['postal']}`}
                  </span>
                </div>
              </div>
            );
          } else {
            return (
              <div className="sig-block" key={sigUser['dealUser']['id']}>
                <div className="sig-holder">
                  <img
                    src={sigUser['dealUser']['signature']}
                    role="presentation"
                  />
                </div>
                <div className="deal-user-info">
                  <span className="deal-user-name">
                    <strong>{sigUser['name']}</strong>
                  </span>
                  <span className="deal-user-email">{sigUser['email']}</span>
                  <span className="deal-user-address">
                    {sigUser['address']}
                  </span>
                  <span className="deal-user-address">
                    {sigUser['city']
                      ? `${sigUser['city']}, ${sigUser['state']} ${sigUser['postal']}`
                      : `${sigUser['state']} ${sigUser['postal']}`}
                  </span>
                </div>
              </div>
            );
          }
        })}

        {options.hasWork && (
          <h4 className="text-center">
            <u>&nbsp;&nbsp;Schedule A – The Work(s)&nbsp;&nbsp;</u>
          </h4>
        )}
        {options.hasWork && (
          <p className="text-center">
            To the Agreement dated {options['dateEffect']}
            <br />
            Between {options['owner']} and {options['contributor']}
          </p>
        )}
      </div>
    );
  };

  render() {
    const { works } = this.props;
    const dates = [];

    if (works.length) {
      works.forEach((work) => {
        if (work.date_accepted) {
          let dateEffect = moment(work.date_accepted).format('MMM/DD/YYYY');
          dates.push(dateEffect);
        }
      });
    }

    return (
      <div className="agreement-text">
        <div className="subheading">WORK-FOR-HIRE AGREEMENT</div>
        {this.loadAgreementText()}
        {this.renderWorks()}
      </div>
    );
  }
}

AgreementTextWorkForHire.defaultProps = {
  works: [],
  isTestVersion: true,
};

const mapStateToProps = (state, props) => ({
  profile: state.profile,
  fields: state.create.fields,
  roles: state.global.roles,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
  contractBlocks: state.global.contractBlocks,
  agreementContractBlocks: state.agreements.contractBlocks,
  dealBlocks: selectDealBlocksState(state, props),
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
});

export default connect(mapStateToProps)(AgreementTextWorkForHire);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementTextWorkForHire.jsx